import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpinnerSvgIcon, TableRow, Typography } from '@/core/ui';
import { LoadingTableCell, SpinnerContainer } from './TableBodyEmpty.styled';
import { t } from '@/core/localization';
import { getTableBodyEmptyErrorMessage } from './getTableBodyEmptyErrorMessage';
const returnMessage = '##.component.should.be.removed.at.all.##';
const TableBodyEmpty = ({ isLoading, isError, error, columnCount, isEmpty, isSearch, isWaitingForSocketConnection, height, width, fitCell, }) => {
    // TODO: to delete later, if everything works fine.
    // const emptySet = !isLoading && !isError && isEmpty;
    // if (!emptySet) return <></>;
    const key = isLoading ? 'loading' : isError ? 'error' : 'emptySet';
    const message = isWaitingForSocketConnection
        ? t('establishing.a.realtime.connection.label')
        : // : isLoading // TODO: to delete later
            isLoading && isEmpty // TODO: (task for claude) This was the bugfix, but it is not working.
                ? t('loading.ellipsis.label')
                : isError
                    ? getTableBodyEmptyErrorMessage(error)
                    : isSearch && isEmpty
                        ? t('nothing.found.matching.your.request')
                        : // : t('there.are.no.items');
                            isEmpty
                                ? t('there.are.no.items')
                                : returnMessage;
    if (message === returnMessage)
        return _jsx(_Fragment, {});
    return (_jsx(TableRow, { children: _jsx(LoadingTableCell, { colSpan: columnCount, component: "td", width: width, fitCell: fitCell, children: _jsxs(SpinnerContainer, { height: height, children: [(isLoading || isWaitingForSocketConnection) && _jsx(SpinnerSvgIcon, {}), _jsx(Typography, { variant: "body2", children: message })] }) }) }, key));
};
export { TableBodyEmpty };
